export default __webpack_public_path__ + "static/jaimin-52331780b524fe46d07bd7a0abbc189d.svg";